/**
 * Helpers for how an Image / Logo picture fills its box. These are stored as
 * ordinary style values per device size (objectFit / objectPosition), so a
 * picture can be cropped one way on desktop and another on a phone.
 */

export const IMAGE_TYPES = ['image', 'logo'];

export const isImageType = (type) => IMAGE_TYPES.includes(type);

export const FIT_OPTIONS = [
    { value: '', label: 'Default (as sized)' },
    { value: 'cover', label: 'Fill the box (crops the edges)' },
    { value: 'contain', label: 'Whole picture inside the box' },
    { value: 'fill', label: 'Stretch to the box' },
];

const clamp = (n) => Math.min(100, Math.max(0, Math.round(n)));

/** '30% 70%' -> { x: 30, y: 70 }; anything else (unset, keywords) -> the centre. */
export function parseObjectPosition(value) {
    const match = /^\s*(-?\d+(?:\.\d+)?)%\s+(-?\d+(?:\.\d+)?)%\s*$/.exec(value || '');
    if (!match) return { x: 50, y: 50 };
    return { x: clamp(Number(match[1])), y: clamp(Number(match[2])) };
}

export function objectPositionValue(x, y) {
    return `${clamp(x)}% ${clamp(y)}%`;
}
